import React from 'react';
import './Home.css';
import jason from '../pic/jason-z.jpg';

const Home = () => {
  return (
    <div className="home">
      <h2 className="home-title">&lt;Home&gt;</h2>
      <div className="home-wrapper">
        <div className="home-content">
          <div className="text-section">
            <span className="greeting">— Hello</span>
            <h1 className="intro">I'm Jason Zheng.</h1>
            <p className="description">
              I graduated Cum Laude from the University at Buffalo with a B.S. in Computer Science 
              and I'm currently pursuing my Master's at NYU. At The Musicians Club, I redesigned 
              their Shopify homepage and engineered a custom-coded menu to navigate 30,000+ products. 
              I've developed full-stack projects like Sprint Spark, a workflow automation platform 
              integrating Jira, GitHub, and Confluence with AWS deployment, and Team Up, a bilingual 
              gaming forum. I'm seeking full-time opportunities in Software or Web Development where 
              I can build scalable, user-centered applications that solve real problems.
            </p>
          </div>
          <div className="image-section">
            <img src={jason} alt="Jason Zheng" className="profile-image" />
          </div>
        </div>
      </div>
    </div>
  );
};


export default Home;